import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"

import {
  getSelectedIndex,
  initHeaderElems,
  unselectAllToc,
  selectIndex,
  dirtyMdxTocParse,
} from "../utils/post_utils.js"

import { rhythm } from "../utils/typography"

const SIDEBAR_CONTAINER_ID = "sidebar_container"

class TableOfContents extends React.Component {
  constructor(props) {
    super(props)
    this.state = { selectedIndex: 0 }

    if (typeof window !== `undefined`) {
      let that = this
      window.onscroll = function() {
        if (typeof that.header_elems !== `undefined`) {
          let selectedIndex = getSelectedIndex(that.header_elems)
          that.setState({ selectedIndex: selectedIndex })
        }

        if (typeof that.sidebarOffset !== `undefined`) {
          if (window.pageYOffset > that.sidebarOffset) {
            that.sidebar_container.classList.add("sticky")
            that.sidebar_container.classList.remove("disable_scroll")
          } else {
            that.sidebar_container.classList.remove("sticky")
            that.sidebar_container.classList.add("disable_scroll")
          }
        }
      }
    }
  }

  render() {
    // require("../utils/post_utils.js")
    return (
      <div
        id={SIDEBAR_CONTAINER_ID}
        className={"disable_scroll"}
        css={css`
          padding-top: ${rhythm(1)};
        `}
      >
        <div id="toc" css={{ width: this.props.width }}>
          <h3>Contents</h3>
          {dirtyMdxTocParse(this.props.toc_data)}
        </div>
      </div>
    )
  }

  componentDidMount() {
    this.toc_elems = document.querySelectorAll("#toc a")
    this.header_elems = initHeaderElems(this.toc_elems)
    this.sidebar_container = document.getElementById(SIDEBAR_CONTAINER_ID)
    this.sidebarOffset = this.sidebar_container.offsetTop
  }

  componentDidUpdate() {
    unselectAllToc(this.toc_elems)
    selectIndex(this.toc_elems, this.state.selectedIndex)
  }
}

export default TableOfContents
